/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_H1_EmInputs */

const es_landing_hero_h1_em = /** @type {(inputs: Landing_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pague solo.`)
};

const gl_landing_hero_h1_em = /** @type {(inputs: Landing_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`páguese só.`)
};

const en_landing_hero_h1_em = /** @type {(inputs: Landing_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pay for itself.`)
};

/**
* | output |
* | --- |
* | "pay for itself." |
*
* @param {Landing_Hero_H1_EmInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_hero_h1_em = /** @type {((inputs?: Landing_Hero_H1_EmInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_H1_EmInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_hero_h1_em(inputs)
	if (locale === "en") return en_landing_hero_h1_em(inputs)
	return es_landing_hero_h1_em(inputs)
});